import(/* webpackMode: "eager" */ "/var/www/cara-front-new/app/[locale]/error.tsx");
